import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";
import { getStorage } from "firebase/storage"; // ✅ Add this
import { getFunctions } from "firebase/functions";


const firebaseConfig = {
  apiKey: "AIzaSyCKLCICEoM76OPMvP6ojWczGgr76iKPNBE",
  authDomain: "sbleducationalportal.firebaseapp.com",
  projectId: "sbleducationalportal",
  storageBucket: "sbleducationalportal.firebasestorage.app", // ✅ FIXED BUCKET NAME!
  messagingSenderId: "341887740482",
  appId: "1:341887740482:web:e39a04a8b836e1c3cd1bdb",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize services
const db = getFirestore(app);
const auth = getAuth(app);
const storage = getStorage(app); // ✅ This is what was missing
const functions = getFunctions(app);

export { app, db, auth, storage, functions };
